import React from 'react';
import InteriorImage from "../../images/interior.png";
import constructionImage from "../../images/construction.png";

const InteriorDesignAndConstruction = () => {
  return (
    <div className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Interior Design Service */}
        <div className="mb-20">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            {/* Text Content */}
            <div className="lg:w-1/2 order-2 lg:order-1">
              <div className="inline-block px-4 py-1 bg-amber-100 text-amber-700 rounded-full text-sm font-semibold mb-4">
                ✦ Design Excellence
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight">
                Interior Design<br />
                <span className="text-amber-500">Excellence</span>
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                We transform spaces into breathtaking environments that reflect your personality 
                and enhance your lifestyle. From concept to completion, we blend artistry with 
                functionality to create homes that tell your unique story.
              </p>
              <div className="space-y-3 mb-6">
                <div className="flex items-center group">
                  <div className="w-2 h-2 bg-amber-500 rounded-full mr-3 group-hover:scale-150 transition-transform"></div>
                  <span className="text-gray-700">Customized design solutions</span>
                </div>
                <div className="flex items-center group">
                  <div className="w-2 h-2 bg-amber-500 rounded-full mr-3 group-hover:scale-150 transition-transform"></div>
                  <span className="text-gray-700">3D visualization & planning</span>
                </div>
                <div className="flex items-center group">
                  <div className="w-2 h-2 bg-amber-500 rounded-full mr-3 group-hover:scale-150 transition-transform"></div>
                  <span className="text-gray-700">Premium material selection</span>
                </div>
              </div>
            </div>

            {/* Image with overlay effect */}
            <div className="lg:w-1/2 order-1 lg:order-2">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <div className="absolute inset-0 bg-gradient-to-t from-amber-500/20 to-transparent z-10"></div>
                <img 
                  src={InteriorImage} 
                  alt="Interior Design" 
                  className="w-full h-80 lg:h-[400px] object-cover transform hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/60 to-transparent z-20">
                  <p className="text-white text-sm font-light tracking-wide">✦ Premium Interior Design</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Construction Service */}
        <div>
          <div className="flex flex-col lg:flex-row items-center gap-12">
            {/* Text Content */}
            <div className="lg:w-1/2 order-2 lg:order-2">
              <div className="inline-block px-4 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-4">
                ✦ Construction Excellence
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight">
                Quality<br />
                <span className="text-blue-500">Construction</span>
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Building dreams with precision and craftsmanship. Our construction team delivers 
                exceptional quality with attention to detail, ensuring your project is completed 
                on time and to the highest standards.
              </p>
              <div className="space-y-3 mb-6">
                <div className="flex items-center group">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-3 group-hover:scale-150 transition-transform"></div>
                  <span className="text-gray-700">Turnkey construction solutions</span>
                </div>
                <div className="flex items-center group">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-3 group-hover:scale-150 transition-transform"></div>
                  <span className="text-gray-700">Quality assurance & project management</span>
                </div>
                <div className="flex items-center group">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-3 group-hover:scale-150 transition-transform"></div>
                  <span className="text-gray-700">Timely delivery guaranteed</span>
                </div>
              </div>
            </div>

            {/* Image with overlay effect */}
            <div className="lg:w-1/2 order-1 lg:order-1">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <div className="absolute inset-0 bg-gradient-to-t from-blue-500/20 to-transparent z-10"></div>
                <img 
                  src={constructionImage} 
                  alt="Construction" 
                  className="w-full h-80 lg:h-[400px] object-cover transform hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/60 to-transparent z-20">
                  <p className="text-white text-sm font-light tracking-wide">✦ Premium Construction Services</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* WhatsApp Contact - Enhanced Design */}
        <div className="mt-20 text-center bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-10 lg:p-14 shadow-xl border border-gray-200/50">
          <div className="max-w-2xl mx-auto">
            <div className="inline-block p-3 bg-green-100 rounded-full mb-4">
              <span className="text-4xl">💬</span>
            </div>
            <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Ready to Start Your Project?
            </h3>
            <p className="text-lg text-gray-600 mb-8">
              Contact us on WhatsApp for a free consultation
            </p>
            <a 
              href="https://wa.me/+923487172565" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-gradient-to-r from-green-500 to-green-600 text-white px-10 py-5 rounded-2xl hover:from-green-600 hover:to-green-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
            >
              <span className="text-2xl">💬</span>
              <span className="font-semibold text-lg">Chat on WhatsApp</span>
            </a>
            <div className="mt-4 flex items-center justify-center gap-2 text-gray-500">
              <span className="text-sm">📞</span>
              <span className="text-sm font-medium">03487172565</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default InteriorDesignAndConstruction;